
interface IdentityVerificationRequest {
    type            : 'verify' | 'adult';
    verifyPromise   : Promise<string | null>;
    handleResult?   : (result:IdentityVerificationResult | null) => void;
}

interface IdentityVerificationResult {
    id: string;
    isRequestVerifyAdult: boolean;
}

export interface IdentityVerificationContext {
    verifyPath? : string;
    request?    : IdentityVerificationRequest;
    verificationId?         : string;
    adultVerificationId?    : string;
}

export const useHconIdentityVerification = () => {
    const context   = useState<IdentityVerificationContext>('_hconIdentityVerificationContext', () => ({}));
    const path      = useRoute().path;
    if (context.value.verifyPath != path) {
        context.value.verifyPath            = path;
        context.value.request               = undefined;
        context.value.verificationId        = undefined;
        context.value.adultVerificationId   = undefined;
    }
    return {
        /**
         * 본인인증 context를 반환합니다.
         * 비지니스 개발측에서는 사용할 필요 없습니다.
         * @returns 
         */
        getContext: () => {
            return context;
        },
        /**
         * 본인인증 요청합니다.
         * 해당 page내에서 이미 인증된적이 있다면 즉시 결과를 제공합니다.
         * @param type 'verify' 혹은 'adult'를 선택할 수 있으며, 처리 결과엔 영향을 주지 않고, 단순히 다이얼로그상의 제목표시를 위한 구분자역할만 합니다.
         * @returns 인증완료 혹은 취소시 결과를 제공받을 수 있는 promise 반환합니다. 인증 취소시 null이 결과로 제공됩니다.
         */
        requestVerify: (type: 'verify' | 'adult') => {
            if (type == 'verify' && context.value.verificationId) {
                return cu.promiseOf(context.value.verificationId);
            } else if (type == 'adult' && context.value.adultVerificationId) {
                return cu.promiseOf(context.value.adultVerificationId);
            }
            if (context.value.request?.verifyPromise) {
                return context.value.request?.verifyPromise;
            }
            let newResultHandler    = null;
            context.value.request = {
                type: type,
                verifyPromise: new Promise<IdentityVerificationResult | null>((rh) => newResultHandler = rh)
                                        .then(result => {
                                            if (result) {
                                                if (result.isRequestVerifyAdult) {
                                                    context.value.adultVerificationId = result.id;
                                                } else {
                                                    context.value.verificationId = result.id;
                                                }
                                            }
                                            return result ? result.id : null;
                                        }),
            };
            if (newResultHandler != null) {
                context.value.request.handleResult = newResultHandler;
            }
            return context.value.request.verifyPromise;
        },
        /**
         * 해당 page 내에서 이미 본인인증(성인인증아닌)처리 되었는지 여부를 반환합니다.
         * @returns 인증처리 된 적이 있다면 true
         */
        isVerified: () => {
            return context.value.verificationId !== undefined;
        },
        /**
         * page내에서 재사용되는 본인인증(성인인증아닌)결과를 삭제하고 다시 인증처리 할수 있게 합니다.
         */
        clear: () => {
            context.value.verificationId  = undefined;
        }
    }
}
